import { useEffect } from "react";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { setMenuActive } from "../../actions/menuAction";
// import ProfileCard from "../ProfileCard";
import "./Sidebar.css";
const Sidebar = () => {
  const moreNavItems = useRef(null);
  const [heightMoreOne, setHeightMoreOne] = useState(false);
  const [heightMoreTwo, setHeightMoreTwo] = useState(false);
  const [sidebarActive, setSidebarActive] = useState("");
  const { menu: menuName } = useSelector((state) => state.menu);
  const history = useHistory();
  const dispatch = useDispatch();
  const { mode } = useSelector((state) => state.mode);
  const userInfo =
    localStorage.getItem("gsprklUserInfo") &&
    JSON.parse(localStorage.getItem("gsprklUserInfo"));
  const teacherMode =
    mode === "teacher" || mode === "learning" || mode === "teaching";
  const moreSidebarIn = () => {
    moreNavItems.current.classList.add("show");
  };
  const moreSidebarOut = () => {
    moreNavItems.current.classList.remove("show");
  };
  const movePage = (page) => {
    history.push(`/${page}`);
    setSidebarActive(menuName);
    dispatch(setMenuActive(page));
  };
  useEffect(() => {
    // show new items at cetains height
    if (window.innerHeight >= 730 && window.innerWidth > 900) {
      setHeightMoreOne(true);
    } else {
      setHeightMoreOne(false);
    }
    if (window.innerHeight >= 780 && window.innerWidth > 900) {
      setHeightMoreTwo(true);
    } else {
      setHeightMoreTwo(false);
    }

    setSidebarActive(
      menuName === ""
        ? history.location.pathname.substr(1)
        : menuName.toLowerCase() === "dashboard"
        ? ""
        : menuName.toLowerCase()
    );

    window.onresize = () => {
      // show new items at cetains height
      if (window.innerHeight >= 730 && window.innerWidth >= 900) {
        setHeightMoreOne(true);
      } else {
        setHeightMoreOne(false);
      }
      if (window.innerHeight >= 780 && window.innerWidth >= 900) {
        setHeightMoreTwo(true);
      } else {
        setHeightMoreTwo(false);
      }
    };
  }, [setSidebarActive, history, menuName, sidebarActive]);
  return (
    <aside className="sidebar flex-column">
      <nav className="sidebar__nav">
        <ul className="sidebar__navItems">
          <li
            className={`sidebar__navItem ${sidebarActive === "" && "active"}`}
            onClick={() => movePage("")}
          >
            <svg
              width="123"
              height="96"
              viewBox="0 0 123 96"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M49.0087 42.6875L45.3787 46.3175V39.1075L49.0087 42.6875ZM104.479 14.3375H104.749C105.118 14.3381 105.482 14.42 105.815 14.5772C106.149 14.7345 106.444 14.9634 106.679 15.2475C118.009 26.9875 124.009 52.4776 122.709 69.5376C122.501 73.6761 121.542 77.7422 119.879 81.5376C118.139 85.1176 115.629 87.4676 112.269 88.0876C107.989 88.8776 102.639 86.6176 96.2087 80.0876C95.3787 79.2476 94.5187 78.3975 93.6387 77.5275C90.411 74.5252 87.4561 71.2423 84.8087 67.7176H38.0887C35.4425 71.2585 32.4803 74.552 29.2387 77.5575C28.3687 78.4175 27.5087 79.2576 26.6887 80.0876C20.2587 86.6376 14.9087 88.8976 10.6287 88.0876C7.26872 87.4976 4.74872 85.1076 3.00872 81.5676C1.34664 77.7719 0.387743 73.7059 0.178717 69.5676C-1.14128 52.3976 4.90872 26.7575 16.4087 15.1075C16.6402 14.8698 16.9169 14.681 17.2227 14.5521C17.5284 14.4233 17.8569 14.3571 18.1887 14.3575H18.4687C25.5587 4.59755 41.4687 4.49755 48.5587 14.3575H56.4687C56.4687 14.3575 61.1348 14.24 61.4387 14.3675C61.7426 14.4951 61.2569 14.1323 61.4878 14.3675H61.4387C61.4387 14.0387 61.5647 14.6713 61.4387 14.3675H74.3487C81.4187 4.57755 97.3487 4.54755 104.439 14.3675L104.479 14.3375ZM39.1987 30.1075V36.7675H45.8587C53.3987 36.7675 53.3987 48.1675 45.8587 48.1675H39.1987V54.8275C39.1987 62.3675 27.7987 62.3675 27.7987 54.8275V48.1775H21.1387C13.5987 48.1775 13.5987 36.7775 21.1387 36.7775H27.7987V30.1075C27.7987 22.5675 39.1987 22.5675 39.1987 30.1075ZM91.2787 24.3075C92.0142 25.0432 92.515 25.9805 92.7178 27.0008C92.9206 28.0211 92.8163 29.0786 92.4182 30.0396C92.02 31.0007 91.3458 31.8221 90.4808 32.4C89.6159 32.9779 88.599 33.2863 87.5587 33.2863C86.5185 33.2863 85.5016 32.9779 84.6366 32.4C83.7716 31.8221 83.0974 31.0007 82.6993 30.0396C82.3011 29.0786 82.1968 28.0211 82.3997 27.0008C82.6025 25.9805 83.1033 25.0432 83.8387 24.3075C84.3265 23.8177 84.9062 23.4291 85.5446 23.1639C86.183 22.8987 86.8675 22.7622 87.5587 22.7622C88.25 22.7622 88.9345 22.8987 89.5728 23.1639C90.2112 23.4291 90.7909 23.8177 91.2787 24.3075ZM91.2787 47.2475C92.0142 47.9832 92.515 48.9205 92.7178 49.9408C92.9206 50.9611 92.8163 52.0186 92.4182 52.9796C92.02 53.9407 91.3458 54.7621 90.4808 55.34C89.6159 55.9179 88.599 56.2263 87.5587 56.2263C86.5185 56.2263 85.5016 55.9179 84.6366 55.34C83.7716 54.7621 83.0974 53.9407 82.6993 52.9796C82.3011 52.0186 82.1968 50.9611 82.3997 49.9408C82.6025 48.9205 83.1033 47.9832 83.8387 47.2475C84.3265 46.7577 84.9062 46.3691 85.5446 46.1039C86.183 45.8387 86.8675 45.7022 87.5587 45.7022C88.25 45.7022 88.9345 45.8387 89.5728 46.1039C90.2112 46.3691 90.7909 46.7577 91.2787 47.2475ZM103.899 35.2475C104.634 35.9832 105.135 36.9205 105.338 37.9408C105.541 38.9611 105.436 40.0186 105.038 40.9796C104.64 41.9407 103.966 42.7621 103.101 43.34C102.236 43.9179 101.219 44.2263 100.179 44.2263C99.1385 44.2263 98.1216 43.9179 97.2566 43.34C96.3916 42.7621 95.7175 41.9407 95.3193 40.9796C94.9211 40.0186 94.8168 38.9611 95.0197 37.9408C95.2225 36.9205 95.7233 35.9832 96.4587 35.2475C97.4465 34.2632 98.7842 33.7104 100.179 33.7104C101.573 33.7104 102.911 34.2632 103.899 35.2475ZM78.6487 35.2475C79.3842 35.9832 79.885 36.9205 80.0878 37.9408C80.2906 38.9611 80.1863 40.0186 79.7882 40.9796C79.39 41.9407 78.7158 42.7621 77.8508 43.34C76.9859 43.9179 75.969 44.2263 74.9287 44.2263C73.8885 44.2263 72.8716 43.9179 72.0066 43.34C71.1416 42.7621 70.4675 41.9407 70.0693 40.9796C69.6711 40.0186 69.5668 38.9611 69.7697 37.9408C69.9725 36.9205 70.4733 35.9832 71.2087 35.2475C71.6965 34.7577 72.2762 34.3691 72.9146 34.1039C73.553 33.8387 74.2374 33.7022 74.9287 33.7022C75.62 33.7022 76.3045 33.8387 76.9428 34.1039C77.5812 34.3691 78.1609 34.7577 78.6487 35.2475ZM33.6487 27.3675L37.2787 30.9975H30.0587L33.6887 27.3675H33.6487ZM18.3987 42.6875L22.0087 46.3175V39.1075L18.3787 42.7375L18.3987 42.6875ZM33.6887 57.9676L37.3187 54.3375H30.0587L33.6887 57.9676Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="122.88" height="95.16" fill="white" />
                </clipPath>
              </defs>
            </svg>

            <p>Gaming Feed</p>
          </li>
          <li
            className={`sidebar__navItem ${
              sidebarActive === "videos" && "active"
            }`}
            onClick={() => movePage("videos")}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 12.0058C2 6.48625 6.48842 2 12 2C17.5116 2 22 6.48625 22 12.0058C22 17.5137 17.5116 22 12 22C6.48842 22 2 17.5137 2 12.0058ZM15.668 13.0178C15.7741 12.9117 15.9093 12.7477 15.9382 12.7091C16.0927 12.5065 16.1699 12.2557 16.1699 12.0058C16.1699 11.725 16.083 11.4645 15.9189 11.2523C15.9055 11.2388 15.8791 11.2102 15.8448 11.1728C15.7806 11.103 15.6885 11.0026 15.6004 10.9146C14.8089 10.0656 12.7432 8.67631 11.6622 8.25181C11.4981 8.18524 11.083 8.03956 10.861 8.02991C10.6486 8.02991 10.4459 8.07815 10.2529 8.17463C10.0116 8.3097 9.81853 8.52195 9.71236 8.77279C9.64479 8.94645 9.53861 9.46744 9.53861 9.47709C9.43243 10.0463 9.37452 10.9725 9.37452 11.9952C9.37452 12.9706 9.43243 13.8572 9.51931 14.4361C9.52169 14.4385 9.53 14.4799 9.5429 14.5442C9.58211 14.7397 9.6638 15.1471 9.75097 15.314C9.96332 15.7192 10.3784 15.9701 10.8224 15.9701H10.861C11.1506 15.9604 11.7587 15.7096 11.7587 15.7C12.7819 15.2754 14.7992 13.9537 15.61 13.0757L15.668 13.0178Z"
                fill="white"
              />
            </svg>

            <p>Videos Feed</p>
          </li>

          {/* this messahe for mobile */}
          <li className="sidebar__navItem messageMobile">
            <svg
              width="24"
              height="24"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.6667 9.16667C18.6667 6.03705 16.1296 3.5 13 3.5C9.87039 3.5 7.33333 6.03705 7.33333 9.16667C7.33333 15.7778 4.5 17.6667 4.5 17.6667H21.5C21.5 17.6667 18.6667 15.7778 18.6667 9.16667"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeline="round"
              />
              <path
                d="M15.2295 22.4998C14.8717 23.1166 14.2126 23.4963 13.4995 23.4963C12.7865 23.4963 12.1273 23.1166 11.7695 22.4998"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeline="round"
              />
              <path
                d="M8 5L7 8.5L6.5 11.5L5.5 15L4 17.5H8.5H15.5L20.5 17L19.5 14L18.5 12V8.5L16.5 4.5L14.5 3H12.5L10 3.5L8 5Z"
                fill="white"
              />
            </svg>
          </li>
          {/* {heightMoreOne && ( */}

          <li
            className={`sidebar__navItem images ${
              sidebarActive === "earn-money" && "active"
            }`}
            onClick={() => movePage("earn-money")}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 322 322"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M297 161C297 86.0098 235.99 25 161 25C86.0086 25 25 86.0098 25 161C25 235.99 86.0086 297 161 297C235.991 297 297 235.99 297 161ZM196.038 212.203C189.271 219.872 179.948 224.534 167.767 226.489V243.783H154.385V226.64C143.858 225.436 135.287 221.378 128.67 214.911C122.054 208.293 117.692 198.821 115.889 186.79L139.949 184.083C140.851 188.895 142.656 193.105 145.361 196.714C148.068 200.324 151.076 202.881 154.385 204.534V165.736C142.504 162.277 133.632 157.165 128.068 150.098C122.504 143.181 119.647 134.608 119.647 124.684C119.647 114.608 122.805 106.036 129.121 99.2696C135.587 92.3526 143.858 88.4417 154.385 87.3904V78.217H167.767V87.3904C177.692 88.4417 185.512 91.9021 191.227 97.3148C197.091 102.879 200.85 110.248 202.353 119.571L179.045 122.579C177.542 115.36 173.783 110.398 167.766 107.842V143.933C182.653 147.842 192.729 153.106 198.142 159.421C203.556 165.888 206.113 174.007 206.113 184.083C206.115 195.21 202.806 204.534 196.038 212.203Z"
                fill="black"
              />
              <path
                d="M167.767 169.796V206.037C172.429 204.986 176.189 202.729 179.197 199.42C182.054 195.961 183.557 191.901 183.557 187.239C183.557 183.18 182.354 179.57 179.797 176.714C177.392 173.706 173.481 171.3 167.767 169.796Z"
                fill="black"
              />
              <path
                d="M145.813 113.856C143.708 116.713 142.656 120.022 142.656 123.631C142.656 126.789 143.708 129.947 145.513 132.653C147.468 135.51 150.475 137.765 154.385 139.421V107.389C150.775 108.743 147.918 110.848 145.813 113.856Z"
                fill="black"
              />
            </svg>

            <p>Earn Money</p>
          </li>
          <li className="sidebar__navItem account">
            <svg
              width="20"
              height="20"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M24 30.3479C32.6773 30.3479 40 31.7579 40 37.1979C40 42.64 32.6292 44 24 44C15.3247 44 8 42.59 8 37.1499C8 31.7079 15.3708 30.3479 24 30.3479ZM24 4C29.8782 4 34.588 8.70805 34.588 14.5821C34.588 20.4562 29.8782 25.1662 24 25.1662C18.1238 25.1662 13.412 20.4562 13.412 14.5821C13.412 8.70805 18.1238 4 24 4Z"
                fill="white"
              />
            </svg>
          </li>
          {/* )} */}
          {/* this account for mobile */}
          <li className="sidebar__navItem account">
            <svg
              width="20"
              height="20"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M24 30.3479C32.6773 30.3479 40 31.7579 40 37.1979C40 42.64 32.6292 44 24 44C15.3247 44 8 42.59 8 37.1499C8 31.7079 15.3708 30.3479 24 30.3479ZM24 4C29.8782 4 34.588 8.70805 34.588 14.5821C34.588 20.4562 29.8782 25.1662 24 25.1662C18.1238 25.1662 13.412 20.4562 13.412 14.5821C13.412 8.70805 18.1238 4 24 4Z"
                fill="white"
              />
            </svg>
          </li>
          <li
            onClick={() => movePage("shop")}
            className={`sidebar__navItem shop-nav ${
              sidebarActive === "shop" && "active"
            }`}
          >
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.8526 37.8157C16.5113 37.8157 17.8703 39.2036 17.8703 40.9181C17.8703 42.6121 16.5113 44 14.8526 44C13.1739 44 11.815 42.6121 11.815 40.9181C11.815 39.2036 13.1739 37.8157 14.8526 37.8157ZM37.3351 37.8157C38.9938 37.8157 40.3528 39.2036 40.3528 40.9181C40.3528 42.6121 38.9938 44 37.3351 44C35.6564 44 34.2975 42.6121 34.2975 40.9181C34.2975 39.2036 35.6564 37.8157 37.3351 37.8157ZM5.55645 4.00024L5.76011 4.01748L10.5264 4.7502C11.2059 4.8747 11.7055 5.44415 11.7654 6.13809L12.1451 10.71C12.2051 11.3651 12.7247 11.855 13.3642 11.855H40.3532C41.5722 11.855 42.3716 12.2836 43.171 13.2225C43.9703 14.1613 44.1102 15.5084 43.9304 16.731L42.0318 30.1201C41.6721 32.6938 39.5138 34.5899 36.9758 34.5899H15.1728C12.5148 34.5899 10.3166 32.5101 10.0967 29.8159L8.25817 7.56681L5.24052 7.03614C4.44114 6.89327 3.88158 6.09727 4.02147 5.28087C4.16136 4.44609 4.94075 3.89297 5.76011 4.01748L5.55645 4.00024ZM33.7783 19.4047H28.2426C27.4032 19.4047 26.7438 20.0782 26.7438 20.9355C26.7438 21.7723 27.4032 22.4662 28.2426 22.4662H33.7783C34.6176 22.4662 35.2771 21.7723 35.2771 20.9355C35.2771 20.0782 34.6176 19.4047 33.7783 19.4047Z"
                fill="white"
              />
            </svg>

            <p>Marketplace</p>
          </li>

          {(heightMoreOne || teacherMode) && (
            <>
              <li
                className={`sidebar__navItem quiz-nav ${
                  sidebarActive === "quiz" && "active"
                }`}
                onClick={() => movePage("quiz")}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.81 2H16.191C19.28 2 21 3.78 21 6.83V17.16C21 20.26 19.28 22 16.191 22H7.81C4.77 22 3 20.26 3 17.16V6.83C3 3.78 4.77 2 7.81 2ZM8.08 6.66V6.65H11.069C11.5 6.65 11.85 7 11.85 7.429C11.85 7.87 11.5 8.22 11.069 8.22H8.08C7.649 8.22 7.3 7.87 7.3 7.44C7.3 7.01 7.649 6.66 8.08 6.66ZM8.08 12.74H15.92C16.35 12.74 16.7 12.39 16.7 11.96C16.7 11.53 16.35 11.179 15.92 11.179H8.08C7.649 11.179 7.3 11.53 7.3 11.96C7.3 12.39 7.649 12.74 8.08 12.74ZM8.08 17.31H15.92C16.319 17.27 16.62 16.929 16.62 16.53C16.62 16.12 16.319 15.78 15.92 15.74H8.08C7.78 15.71 7.49 15.85 7.33 16.11C7.17 16.36 7.17 16.69 7.33 16.95C7.49 17.2 7.78 17.35 8.08 17.31Z"
                    fill="white"
                  />
                </svg>

                <p>Quizzes</p>
              </li>
              <li
                className={`sidebar__navItem images ${
                  sidebarActive === "images" && "active"
                }`}
                onClick={() => movePage("images")}
              >
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M32.6676 4C39.4462 4 44 8.75623 44 15.8334V32.1666C44 39.2438 39.4462 44 32.6656 44H15.3324C8.55379 44 4 39.2438 4 32.1666V15.8334C4 8.75623 8.55379 4 15.3324 4H32.6676ZM34.8732 25.1001C32.7293 23.7626 31.0741 25.6409 30.6276 26.2415C30.1973 26.8215 29.8272 27.4613 29.437 28.1011C28.4837 29.6801 27.3917 31.5005 25.5012 32.5593C22.754 34.0805 20.6684 32.6791 19.1681 31.6594C18.605 31.2797 18.0579 30.9205 17.5129 30.6811C16.1695 30.1011 14.9608 30.7616 13.1668 33.0402C12.2256 34.2312 11.2924 35.4118 10.3472 36.5882C9.78203 37.2921 9.91678 38.3777 10.679 38.8483C11.8958 39.5975 13.38 40 15.0573 40H31.9128C32.864 40 33.8173 39.87 34.7264 39.5728C36.7737 38.904 38.3987 37.3725 39.2474 35.3498C39.9634 33.6491 40.3113 31.5851 39.6416 29.8679C39.4184 29.2982 39.0845 28.7678 38.6159 28.3013C37.3871 27.0815 36.2388 25.9422 34.8732 25.1001ZM16.9977 12C14.2404 12 12 14.2435 12 17C12 19.7565 14.2404 22 16.9977 22C19.753 22 21.9954 19.7565 21.9954 17C21.9954 14.2435 19.753 12 16.9977 12Z"
                    fill="black"
                  />
                </svg>

                <p>Images</p>
              </li>
            </>
          )}
          {(heightMoreTwo || teacherMode) && (
            <>
              <li
                className={`sidebar__navItem communities-nav ${
                  sidebarActive === "communities" && "active"
                }`}
                onClick={() => movePage("communities")}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M23.8981 29.0792C30.7604 29.0792 36.6199 30.1672 36.6199 34.5207C36.6199 38.8724 30.798 40 23.8981 40C17.0357 40 11.1762 38.9121 11.1762 34.5603C11.1762 30.2068 16.9981 29.0792 23.8981 29.0792ZM34.8701 26.4578C37.4937 26.4091 40.3142 26.7694 41.3564 27.0251C43.5645 27.4592 45.0168 28.3454 45.6186 29.6333C46.1271 30.6906 46.1271 31.9172 45.6186 32.9727C44.6981 34.9703 41.7307 35.6115 40.5774 35.7772C40.3393 35.8133 40.1476 35.6061 40.1727 35.3666C40.7619 29.8314 36.0754 27.2071 34.863 26.6037C34.811 26.5766 34.8003 26.5352 34.8057 26.51C34.8093 26.492 34.8307 26.4632 34.8701 26.4578ZM12.6372 26.454L13.1312 26.4585C13.1706 26.4639 13.1903 26.4927 13.1939 26.5089C13.1992 26.5359 13.1885 26.5756 13.1384 26.6044C11.9242 27.2078 7.23766 29.8321 7.82683 35.3655C7.8519 35.6068 7.66208 35.8122 7.4239 35.778C6.27062 35.6122 3.30326 34.971 2.38278 32.9735C1.87241 31.9162 1.87241 30.6913 2.38278 29.634C2.9845 28.3461 4.43505 27.46 6.64311 27.0241C7.68715 26.7701 10.5059 26.4098 13.1312 26.4585L12.6372 26.454ZM23.8981 8C28.5703 8 32.3166 11.7645 32.3166 16.4657C32.3166 21.1651 28.5703 24.9332 23.8981 24.9332C19.2258 24.9332 15.4795 21.1651 15.4795 16.4657C15.4795 11.7645 19.2258 8 23.8981 8ZM35.3268 9.41179C39.8396 9.41179 43.3836 13.6825 42.1766 18.4395C41.3618 21.642 38.4124 23.7693 35.1262 23.6828C34.7967 23.6738 34.4726 23.6432 34.1592 23.5891C33.9318 23.5495 33.8172 23.2919 33.9461 23.101C35.1997 21.2458 35.9142 19.0141 35.9142 16.6184C35.9142 14.1184 35.1334 11.7876 33.7778 9.8765C33.7348 9.81706 33.7025 9.7252 33.7455 9.65676C33.7813 9.60092 33.8476 9.5721 33.9103 9.55769C34.3669 9.46403 34.8361 9.41179 35.3268 9.41179ZM12.6719 9.41161C13.1625 9.41161 13.6317 9.46385 14.0902 9.55751C14.1511 9.57192 14.2191 9.60254 14.2549 9.65658C14.2961 9.72502 14.2657 9.81688 14.2227 9.87632C12.8671 11.7874 12.0863 14.1182 12.0863 16.6183C12.0863 19.0139 12.8008 21.2456 14.0544 23.1008C14.1833 23.2918 14.0687 23.5493 13.8413 23.589C13.5261 23.6448 13.2037 23.6736 12.8742 23.6826C9.58809 23.7691 6.63863 21.6419 5.82382 18.4393C4.61502 13.6823 8.15903 9.41161 12.6719 9.41161Z"
                    fill="white"
                  />
                </svg>

                <p>Communities</p>
              </li>
            </>
          )}
          {!heightMoreTwo && !teacherMode && (
            <li
              className="sidebar__navItem more flex-row"
              onMouseEnter={moreSidebarIn}
              onMouseLeave={moreSidebarOut}
            >
              <div className="flex-row">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.54 2H7.92C9.33 2 10.46 3.15 10.46 4.561V7.97C10.46 9.39 9.33 10.53 7.92 10.53H4.54C3.14 10.53 2 9.39 2 7.97V4.561C2 3.15 3.14 2 4.54 2ZM4.54 13.4697H7.92C9.33 13.4697 10.46 14.6107 10.46 16.0307V19.4397C10.46 20.8497 9.33 21.9997 7.92 21.9997H4.54C3.14 21.9997 2 20.8497 2 19.4397V16.0307C2 14.6107 3.14 13.4697 4.54 13.4697ZM19.4601 2H16.0801C14.6701 2 13.5401 3.15 13.5401 4.561V7.97C13.5401 9.39 14.6701 10.53 16.0801 10.53H19.4601C20.8601 10.53 22.0001 9.39 22.0001 7.97V4.561C22.0001 3.15 20.8601 2 19.4601 2ZM16.0801 13.4697H19.4601C20.8601 13.4697 22.0001 14.6107 22.0001 16.0307V19.4397C22.0001 20.8497 20.8601 21.9997 19.4601 21.9997H16.0801C14.6701 21.9997 13.5401 20.8497 13.5401 19.4397V16.0307C13.5401 14.6107 14.6701 13.4697 16.0801 13.4697Z"
                    fill="white"
                  />
                </svg>

                <p>More Options</p>
              </div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                className="sidebar__moreIcon"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.6308 13.131C16.5743 13.189 16.3609 13.437 16.1622 13.641C14.9971 14.924 11.9576 17.024 10.3668 17.665C10.1252 17.768 9.51437 17.986 9.18802 18C8.8753 18 8.5772 17.928 8.29274 17.782C7.93814 17.578 7.65368 17.257 7.49781 16.878C7.39747 16.615 7.2416 15.828 7.2416 15.814C7.08573 14.953 7 13.554 7 12.008C7 10.535 7.08573 9.193 7.21335 8.319C7.22796 8.305 7.38383 7.327 7.55431 6.992C7.86702 6.38 8.47784 6 9.13151 6H9.18802C9.61374 6.015 10.509 6.395 10.509 6.409C12.0141 7.051 14.9834 9.048 16.1768 10.375C16.1768 10.375 16.5129 10.716 16.659 10.929C16.887 11.235 17 11.614 17 11.993C17 12.416 16.8724 12.81 16.6308 13.131Z"
                  fill="white"
                />
              </svg>
            </li>
          )}
        </ul>

        <ul
          className="sidebar__moreNav"
          ref={moreNavItems}
          onMouseEnter={moreSidebarIn}
          onMouseLeave={moreSidebarOut}
        >
          {!heightMoreOne && (
            <>
              <li
                className={`sidebar__navItem quiz-nav ${
                  sidebarActive === "quiz" && "active"
                }`}
                onClick={() => movePage("quiz")}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.81 2H16.191C19.28 2 21 3.78 21 6.83V17.16C21 20.26 19.28 22 16.191 22H7.81C4.77 22 3 20.26 3 17.16V6.83C3 3.78 4.77 2 7.81 2ZM8.08 6.66V6.65H11.069C11.5 6.65 11.85 7 11.85 7.429C11.85 7.87 11.5 8.22 11.069 8.22H8.08C7.649 8.22 7.3 7.87 7.3 7.44C7.3 7.01 7.649 6.66 8.08 6.66ZM8.08 12.74H15.92C16.35 12.74 16.7 12.39 16.7 11.96C16.7 11.53 16.35 11.179 15.92 11.179H8.08C7.649 11.179 7.3 11.53 7.3 11.96C7.3 12.39 7.649 12.74 8.08 12.74ZM8.08 17.31H15.92C16.319 17.27 16.62 16.929 16.62 16.53C16.62 16.12 16.319 15.78 15.92 15.74H8.08C7.78 15.71 7.49 15.85 7.33 16.11C7.17 16.36 7.17 16.69 7.33 16.95C7.49 17.2 7.78 17.35 8.08 17.31Z"
                    fill="white"
                  />
                </svg>

                <p>Quizzes</p>
              </li>
              <li
                className={`sidebar__navItem images ${
                  sidebarActive === "images" && "active"
                }`}
                onClick={() => movePage("images")}
              >
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M32.6676 4C39.4462 4 44 8.75623 44 15.8334V32.1666C44 39.2438 39.4462 44 32.6656 44H15.3324C8.55379 44 4 39.2438 4 32.1666V15.8334C4 8.75623 8.55379 4 15.3324 4H32.6676ZM34.8732 25.1001C32.7293 23.7626 31.0741 25.6409 30.6276 26.2415C30.1973 26.8215 29.8272 27.4613 29.437 28.1011C28.4837 29.6801 27.3917 31.5005 25.5012 32.5593C22.754 34.0805 20.6684 32.6791 19.1681 31.6594C18.605 31.2797 18.0579 30.9205 17.5129 30.6811C16.1695 30.1011 14.9608 30.7616 13.1668 33.0402C12.2256 34.2312 11.2924 35.4118 10.3472 36.5882C9.78203 37.2921 9.91678 38.3777 10.679 38.8483C11.8958 39.5975 13.38 40 15.0573 40H31.9128C32.864 40 33.8173 39.87 34.7264 39.5728C36.7737 38.904 38.3987 37.3725 39.2474 35.3498C39.9634 33.6491 40.3113 31.5851 39.6416 29.8679C39.4184 29.2982 39.0845 28.7678 38.6159 28.3013C37.3871 27.0815 36.2388 25.9422 34.8732 25.1001ZM16.9977 12C14.2404 12 12 14.2435 12 17C12 19.7565 14.2404 22 16.9977 22C19.753 22 21.9954 19.7565 21.9954 17C21.9954 14.2435 19.753 12 16.9977 12Z"
                    fill="black"
                  />
                </svg>

                <p>Images</p>
              </li>
            </>
          )}
          {!heightMoreTwo && (
            <>
              <li
                className={`sidebar__navItem communities-nav ${
                  sidebarActive === "communities" && "active"
                }`}
                onClick={() => movePage("communities")}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M23.8981 29.0792C30.7604 29.0792 36.6199 30.1672 36.6199 34.5207C36.6199 38.8724 30.798 40 23.8981 40C17.0357 40 11.1762 38.9121 11.1762 34.5603C11.1762 30.2068 16.9981 29.0792 23.8981 29.0792ZM34.8701 26.4578C37.4937 26.4091 40.3142 26.7694 41.3564 27.0251C43.5645 27.4592 45.0168 28.3454 45.6186 29.6333C46.1271 30.6906 46.1271 31.9172 45.6186 32.9727C44.6981 34.9703 41.7307 35.6115 40.5774 35.7772C40.3393 35.8133 40.1476 35.6061 40.1727 35.3666C40.7619 29.8314 36.0754 27.2071 34.863 26.6037C34.811 26.5766 34.8003 26.5352 34.8057 26.51C34.8093 26.492 34.8307 26.4632 34.8701 26.4578ZM12.6372 26.454L13.1312 26.4585C13.1706 26.4639 13.1903 26.4927 13.1939 26.5089C13.1992 26.5359 13.1885 26.5756 13.1384 26.6044C11.9242 27.2078 7.23766 29.8321 7.82683 35.3655C7.8519 35.6068 7.66208 35.8122 7.4239 35.778C6.27062 35.6122 3.30326 34.971 2.38278 32.9735C1.87241 31.9162 1.87241 30.6913 2.38278 29.634C2.9845 28.3461 4.43505 27.46 6.64311 27.0241C7.68715 26.7701 10.5059 26.4098 13.1312 26.4585L12.6372 26.454ZM23.8981 8C28.5703 8 32.3166 11.7645 32.3166 16.4657C32.3166 21.1651 28.5703 24.9332 23.8981 24.9332C19.2258 24.9332 15.4795 21.1651 15.4795 16.4657C15.4795 11.7645 19.2258 8 23.8981 8ZM35.3268 9.41179C39.8396 9.41179 43.3836 13.6825 42.1766 18.4395C41.3618 21.642 38.4124 23.7693 35.1262 23.6828C34.7967 23.6738 34.4726 23.6432 34.1592 23.5891C33.9318 23.5495 33.8172 23.2919 33.9461 23.101C35.1997 21.2458 35.9142 19.0141 35.9142 16.6184C35.9142 14.1184 35.1334 11.7876 33.7778 9.8765C33.7348 9.81706 33.7025 9.7252 33.7455 9.65676C33.7813 9.60092 33.8476 9.5721 33.9103 9.55769C34.3669 9.46403 34.8361 9.41179 35.3268 9.41179ZM12.6719 9.41161C13.1625 9.41161 13.6317 9.46385 14.0902 9.55751C14.1511 9.57192 14.2191 9.60254 14.2549 9.65658C14.2961 9.72502 14.2657 9.81688 14.2227 9.87632C12.8671 11.7874 12.0863 14.1182 12.0863 16.6183C12.0863 19.0139 12.8008 21.2456 14.0544 23.1008C14.1833 23.2918 14.0687 23.5493 13.8413 23.589C13.5261 23.6448 13.2037 23.6736 12.8742 23.6826C9.58809 23.7691 6.63863 21.6419 5.82382 18.4393C4.61502 13.6823 8.15903 9.41161 12.6719 9.41161Z"
                    fill="white"
                  />
                </svg>

                <p>Communities</p>
              </li>
            </>
          )}
        </ul>
      </nav>

      <div className="sidebar__bottom">
        {(!teacherMode || userInfo?.plan !== "premium-plan") && (
          <div
            className="sidebar__upgrade flex-column"
            onClick={() =>
              (window.location.href =
                "https://geniusparkle.com/pricing.html?upgrade")
            }
          >
            <div className="sidebar__upgradeImgContainer">
              <img src="/images/icons/crown.svg" alt="crown" />
            </div>
            <strong className="sidebar__upgradePrice">
              $
              {userInfo?.plan === "free-plan" || !userInfo?.plan
                ? "40"
                : userInfo?.plan === "professional-plan"
                ? "50"
                : userInfo?.plan === "value-plan" && "250"}
              <span>/month</span>
            </strong>
            <div className="sidebar__upgradeDesc">
              <h3>Hey, Abraham</h3>
              <p>Want more games and exclusive content?</p>
            </div>
            <button className="btn primary">Upgrade Now</button>
          </div>
        )}
      </div>
    </aside>
  );
};

export default Sidebar;
